import React from "react";
import Card from "react-bootstrap/Card";

const UserBubble = ({ children }) => {
  return <Card className="user-bubble fw-bold">{children}</Card>;
};

export default UserBubble;
